import { useAvatarColor } from '@core/hooks/useAvatarColor';
import { getInitials } from '@core/utils/getInitials';
import { Gamerpic } from '@soteria/design-system-ve';

import { buttonContainer, avatar, avatarInitials, avatarGamerpic } from './UserProfileButton.css';

export interface UserProfileButtonBaseProps {
  /**
   * User data
   */
  user: {
    name: string;
    email?: string;
    avatar?: string;
  };

  /**
   * Callback when the button is clicked
   */
  onClick?: () => void;

  /**
   * Additional CSS class name
   */
  className?: string;

  /**
   * ID for the button element
   */
  id?: string;
}

/**
 * UserProfileButtonBase component that displays a user avatar button without a popover
 * This is useful when you want to implement your own menu/popover
 */
export function UserProfileButtonBase({ user, onClick, className, id }: UserProfileButtonBaseProps) {
  const { avatarBackgroundColor } = useAvatarColor(user.name, user.email);

  return (
    <div className={`${buttonContainer} ${className || ''}`}>
      <button aria-label="User profile" className={avatar} id={id} onClick={onClick}>
        <Gamerpic
          className={avatarGamerpic}
          gamerpicImageComponent={
            user.avatar ? (
              <img alt={user.name} src={user.avatar} />
            ) : (
              <span className={avatarInitials} style={{ backgroundColor: avatarBackgroundColor }}>
                {getInitials(user.name)}
              </span>
            )
          }
          imageAlt={`${user.name} profile picture`}
        />
      </button>
    </div>
  );
}
